import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      font-weight: bold;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Theme } from "@silvertours/front-shared";
var BreadcrumbsContentContainer = /*#__PURE__*/ styled("div", {
    target: "egrx0h0"
})("z-index:10;position:relative;overflow-x:auto;", Theme.mq("sm"), "{margin-bottom:0;overflow-x:auto;}", Theme.mq("lg"), "{position:static;margin:0;}");
var BreadcrumbList = /*#__PURE__*/ styled("ul", {
    target: "egrx0h1"
})("display:inline-flex;flex-flow:row wrap;padding:0 1rem;font-size:0.75rem;", Theme.mq("sm"), "{font-size:inherit;padding:0;}");
var BreadcrumbItem = /*#__PURE__*/ styled("li", {
    target: "egrx0h2"
})("white-space:nowrap;&:not(:last-child)::after{content:'\\0000a0|\\0000a0';}");
var BreadcrumbText = /*#__PURE__*/ styled("span", {
    target: "egrx0h3"
})(function(param) {
    var isLast = param.isLast;
    return !!isLast && css(_templateObject());
});
var BreadcrumbLink = /*#__PURE__*/ styled("a", {
    target: "egrx0h4"
})("color:", Theme.Color.primary, ";text-decoration:none;cursor:pointer;");
export { BreadcrumbsContentContainer, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbText };
